<template>
<div class="slds-var-p-around_small">
	<notifications group="error" position="top center">
			<template slot="body" slot-scope="props">
				<div class="slds-notify_container slds-is-relative">
					<div class="slds-notify slds-notify_toast slds-theme_error" role="status">
					<span class="slds-assistive-text">error</span>
					<span class="slds-icon_container slds-icon-utility-error slds-m-right_small slds-no-flex slds-align-top" title="Description of icon when needed">
						<svg class="slds-icon slds-icon_small" aria-hidden="true">
						<use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#error"></use>
						</svg>
					</span>
					<div class="slds-notify__content">
						<h2 class="slds-text-heading_small" v-html="props.item.title"></h2>
						<p v-html="props.item.text"></p>
					</div>
					<div class="slds-notify__close">
						<button class="slds-button slds-button_icon slds-button_icon-inverse" title="Close" @click="props.close">
							<svg class="slds-button__icon slds-button__icon_large" aria-hidden="true">
								<use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#close"></use>
							</svg>
							<span class="slds-assistive-text">Close</span>
						</button>
					</div>
					</div>
				</div>
			</template>
		</notifications>
		
	<template v-if="!isLanded">
		<div class="vld-parent">
			<loading :active.sync="isLoading" 
			:can-cancel="true" 
			:on-cancel="onCancel"
			:is-full-page="fullPage"></loading>
		</div>
	</template>
	<div class="slds-page-header slds-page-header_record-home">
		<div class="slds-page-header__row">
			<div class="slds-page-header__col-title">
				<div class="slds-media">
				<div class="slds-media__figure">
					<span class="slds-icon_container slds-icon-standard-opportunity">
						<svg class="slds-icon slds-page-header__icon" aria-hidden="true">
							<use xlink:href="/assets/icons/custom-sprite/svg/symbols.svg#custom102"></use>
						</svg>
					</span>
				</div>
				<div class="slds-media__body">
					<div class="slds-page-header__name">
						<div class="slds-page-header__name-title">
							<h1>
							<span></span>
							<span class="slds-page-header__title slds-truncate" title="Analysis">Analysis Report</span>
							</h1>
						</div>
					</div>
				</div>
				</div>
			</div>
			<div class="slds-page-header__col-actions">
				<div class="slds-page-header__controls">
					<div class="slds-page-header__control">
						<ul class="slds-button-group-list">
							<li>
								<button  variant="primary" class="slds-button slds-button_neutral" @click="showFilterPopupModal()">Filters</button>
								
							</li>
							<li>
								<button  variant="primary" class="slds-button slds-button_neutral" @click="searchData()">Summarry Report</button>
								
							</li>
							
						</ul>
					</div>
				</div>
			</div>
		</div>
		<div class="slds-page-header__row slds-page-header__row_gutters">
			
		</div>
		
	</div>
	<template v-if="showList">
		<table class="autoNumber slds-m-top_large slds-table slds-table_fixed-layout slds-table_bordered slds-table_striped slds-no-row-hover slds-table_col-bordered">
			<colgroup>
				<col class="rowNumCol"/>
				<col class="campaignName"/>
				<col span="7" class="numberCol"/>
			</colgroup>
			<thead>
				<tr class="slds-line-height_reset">
					<th scope="col"><div class="slds-truncate">#</div></th>
					<table-head-row :text="'Campaign Id'" :columnKey="'id'" :columnType="''"></table-head-row>
					<table-head-row :text="'# Members'" :columnKey="'memberCount'" :columnType="''"></table-head-row>
					<table-head-row :text="'# Gifts'" :columnKey="'numberOfGifts'" :columnType="''"></table-head-row>
					<table-head-row :text="'$ Gifts'" :columnKey="'amountOfGifts'" :columnType="'number'"></table-head-row>
					<table-head-row :text="'Cost of Campaign'" :columnKey="'Total_Cost_of_Campaign__c'" :columnType="'date'"></table-head-row>
					<table-head-row :text="'Cost / Price'" :columnKey="'costPrice'" :columnType="'number'"></table-head-row>
					<table-head-row :text="'Response Rate'" :columnKey="'responseRate'" :columnType="''"></table-head-row>
					<table-head-row :text="'In / Out'" :columnKey="'inOutCost'" :columnType="''"></table-head-row>
				</tr>
				<tr class="slds-line-height_reset">
					<th></th>
					<table-head-cell-filter :colName="'CampaignId'" :colKey="'id'" :colType="''"></table-head-cell-filter>
					<table-head-cell-filter :colName="'# Members'" :colKey="'memberCount'" :colType="''"></table-head-cell-filter>
					<table-head-cell-filter :colName="'# Gifts'" :colKey="'numberOfGifts'" :colType="''"></table-head-cell-filter>
					<table-head-cell-filter :colName="'$ Gifts'" :colKey="'amountOfGifts'" :colType="'number'"></table-head-cell-filter>
					<table-head-cell-filter :colName="'Cost of Campaign'" :colKey="'Total_Cost_of_Campaign__c'" :colType="'date'"></table-head-cell-filter>
					<table-head-cell-filter :colName="'Cost / Price'" :colKey="'costPrice'" :colType="'number'"></table-head-cell-filter>
					<table-head-cell-filter :colName="'Response Rate'" :colKey="'responseRate'" :colType="''"></table-head-cell-filter>
					<table-head-cell-filter :colName="'In / Out'" :colKey="'inOutCost'" :colType="''"></table-head-cell-filter>
				</tr>
			</thead>
			<tbody>
				<tr v-for="data in campaignData" :key="data.id">
					<td></td>
					<th scope="row">
						{{data.campaignId}}
					</th>
					<td class="numStyle">{{data.memberCount}}</td>
					<td class="numStyle">{{data.numberOfGifts}}</td>
					<td class="numStyle">{{data.amountOfGifts}}</td>
					<td class="numStyle">{{data.campaignCost}}</td>
					<td class="numStyle">{{data.costPrice}}</td>
					<td class="numStyle">{{data.responseRate}}</td>
					<td class="numStyle">{{data.inOutCost}}</td>
				</tr>
			</tbody>
			
		</table>
	</template>
	<template v-if="showSummary">
		<table class="summaryReport slds-m-top_large slds-table slds-table_fixed-layout slds-table_bordered slds-no-row-hover slds-table_col-bordered" v-if="previousGifts1">
		<thead>
			<tr>
				<th>Months</th>
				<th>> 72</th>
				<th>60 - 71.99</th>
				<th>48 - 59.99</th>
				<th>36 - 47.99</th>
				<th>27 - 35.99</th>
				<th>24 - 26.99</th>
				<th>18 - 23.99</th>
				<th>15 - 17.99</th>
				<th>13 - 14.99</th>
				<th>12 - 12.99</th>
				<th>11 - 11.99</th>
				<th>9 - 10.99</th>
				<th>7 - 8.99</th>
				<th>5 - 6.99</th>
				<th>3 - 4.99</th>
				<th>0 - 2.99</th>
				<th></th>
			</tr>
			<tr>
				<th>Average Gifts</th>
				<th colspan="16">1 Prior Gift</th>
				<th></th>
			</tr>
		</thead>
		<tbody>
			<tr v-for="(row, rowIndex) in tableTemplate" :key="rowIndex">
				<td v-for="(cell, cellIndex) in row" :key="cellIndex" :class="previousGifts1[cell].grade">
					<div class="slds-form-element slds-form-element_stacked">
						<label class="slds-form-element__label slds-no-flex" for="carrierpostagetype">{{ previousGifts1[cell].count | toNumberFormat }}</label>
						<div class="slds-form-element__control" v-if="!(cell.indexOf('rowLabel') > -1 || cell.indexOf('total') > -1)">
							<div class="slds-select_container">
								<select class="slds-select" v-model="previousGifts1[cell].grade">
									<option v-for="grade in grades" :key="grade.name" 
										:value="grade.cssClass">{{grade.name}}</option>
								</select>
							</div>
						</div>
					</div>
				</td>
			</tr>
		</tbody>
		</table>

		<table class="summaryReport slds-m-top_large slds-table slds-table_fixed-layout slds-table_bordered slds-no-row-hover slds-table_col-bordered" v-if="previousGifts2">
		<thead>
			<tr>
				<th>Months</th>
				<th>> 72</th>
				<th>60 - 71.99</th>
				<th>48 - 59.99</th>
				<th>36 - 47.99</th>
				<th>27 - 35.99</th>
				<th>24 - 26.99</th>
				<th>18 - 23.99</th>
				<th>15 - 17.99</th>
				<th>13 - 14.99</th>
				<th>12 - 12.99</th>
				<th>11 - 11.99</th>
				<th>9 - 10.99</th>
				<th>7 - 8.99</th>
				<th>5 - 6.99</th>
				<th>3 - 4.99</th>
				<th>0 - 2.99</th>
				<th></th>
			</tr>
			<tr>
				<th>Average Gifts</th>
				<th colspan="16">2 Prior Gifts</th>
				<th></th>
			</tr>
		</thead>
		<tbody>
			<tr v-for="(row, rowIndex) in tableTemplate" :key="rowIndex">
				<td v-for="(cell, cellIndex) in row" :key="cellIndex" :class="previousGifts2[cell].grade">
					<div class="slds-form-element slds-form-element_stacked">
						<label class="slds-form-element__label slds-no-flex" for="carrierpostagetype">{{ previousGifts2[cell].count | toNumberFormat }}</label>
						<div class="slds-form-element__control" v-if="!(cell.indexOf('rowLabel') > -1 || cell.indexOf('total') > -1)">
							<div class="slds-select_container">
								<select class="slds-select" v-model="previousGifts2[cell].grade">
									<option v-for="grade in grades" :key="grade.name" 
										:value="grade.cssClass">{{grade.name}}</option>
								</select>
							</div>
						</div>
					</div>
				</td>
			</tr>
		</tbody>
		</table>

		<table class="summaryReport slds-m-top_large slds-table slds-table_fixed-layout slds-table_bordered slds-no-row-hover slds-table_col-bordered" v-if="previousGifts3">
		<thead>
			<tr>
				<th>Months</th>
				<th>> 72</th>
				<th>60 - 71.99</th>
				<th>48 - 59.99</th>
				<th>36 - 47.99</th>
				<th>27 - 35.99</th>
				<th>24 - 26.99</th>
				<th>18 - 23.99</th>
				<th>15 - 17.99</th>
				<th>13 - 14.99</th>
				<th>12 - 12.99</th>
				<th>11 - 11.99</th>
				<th>9 - 10.99</th>
				<th>7 - 8.99</th>
				<th>5 - 6.99</th>
				<th>3 - 4.99</th>
				<th>0 - 2.99</th>
				<th></th>
			</tr>
			<tr>
				<th>Average Gifts</th>
				<th colspan="16">3-4 Prior Gifts</th>
				<th></th>
			</tr>
		</thead>
		<tbody>
			<tr v-for="(row, rowIndex) in tableTemplate" :key="rowIndex">
				<td v-for="(cell, cellIndex) in row" :key="cellIndex" :class="previousGifts3[cell].grade">
					<div class="slds-form-element slds-form-element_stacked">
						<label class="slds-form-element__label slds-no-flex" for="carrierpostagetype">{{ previousGifts3[cell].count | toNumberFormat }}</label>
						<div class="slds-form-element__control" v-if="!(cell.indexOf('rowLabel') > -1 || cell.indexOf('total') > -1)">
							<div class="slds-select_container">
								<select class="slds-select" v-model="previousGifts3[cell].grade">
									<option v-for="grade in grades" :key="grade.name" 
										:value="grade.cssClass">{{grade.name}}</option>
								</select>
							</div>
						</div>
					</div>
				</td>
			</tr>
		</tbody>
		</table>

		<table class="summaryReport slds-m-top_large slds-table slds-table_fixed-layout slds-table_bordered slds-no-row-hover slds-table_col-bordered" v-if="previousGifts5">
		<thead>
			<tr>
				<th>Months</th>
				<th>> 72</th>
				<th>60 - 71.99</th>
				<th>48 - 59.99</th>
				<th>36 - 47.99</th>
				<th>27 - 35.99</th>
				<th>24 - 26.99</th>
				<th>18 - 23.99</th>
				<th>15 - 17.99</th>
				<th>13 - 14.99</th>
				<th>12 - 12.99</th>
				<th>11 - 11.99</th>
				<th>9 - 10.99</th>
				<th>7 - 8.99</th>
				<th>5 - 6.99</th>
				<th>3 - 4.99</th>
				<th>0 - 2.99</th>
				<th></th>
			</tr>
			<tr>
				<th>Average Gifts</th>
				<th colspan="16">5-7 Prior Gifts</th>
				<th></th>
			</tr>
		</thead>
		<tbody>
			<tr v-for="(row, rowIndex) in tableTemplate" :key="rowIndex">
				<td v-for="(cell, cellIndex) in row" :key="cellIndex" :class="previousGifts5[cell].grade">
					<div class="slds-form-element slds-form-element_stacked">
						<label class="slds-form-element__label slds-no-flex" for="carrierpostagetype">{{ previousGifts5[cell].count | toNumberFormat }}</label>
						<div class="slds-form-element__control" v-if="!(cell.indexOf('rowLabel') > -1 || cell.indexOf('total') > -1)">
							<div class="slds-select_container">
								<select class="slds-select" v-model="previousGifts5[cell].grade">
									<option v-for="grade in grades" :key="grade.name" 
										:value="grade.cssClass">{{grade.name}}</option>
								</select>
							</div>
						</div>
					</div>
				</td>
			</tr>
		</tbody>
		</table>

		<table class="summaryReport slds-m-top_large slds-table slds-table_fixed-layout slds-table_bordered slds-no-row-hover slds-table_col-bordered" v-if="previousGifts8">
		<thead>
			<tr>
				<th>Months</th>
				<th>> 72</th>
				<th>60 - 71.99</th>
				<th>48 - 59.99</th>
				<th>36 - 47.99</th>
				<th>27 - 35.99</th>
				<th>24 - 26.99</th>
				<th>18 - 23.99</th>
				<th>15 - 17.99</th>
				<th>13 - 14.99</th>
				<th>12 - 12.99</th>
				<th>11 - 11.99</th>
				<th>9 - 10.99</th>
				<th>7 - 8.99</th>
				<th>5 - 6.99</th>
				<th>3 - 4.99</th>
				<th>0 - 2.99</th>
				<th></th>
			</tr>
			<tr>
				<th>Average Gifts</th>
				<th colspan="16">8+ Prior Gifts</th>
				<th></th>
			</tr>
		</thead>
		<tbody>
			<tr v-for="(row, rowIndex) in tableTemplate" :key="rowIndex">
				<td v-for="(cell, cellIndex) in row" :key="cellIndex" :class="previousGifts8[cell].grade">
					<div class="slds-form-element slds-form-element_stacked">
						<label class="slds-form-element__label slds-no-flex" for="carrierpostagetype">{{ previousGifts8[cell].count | toNumberFormat }}</label>
						<div class="slds-form-element__control" v-if="!(cell.indexOf('rowLabel') > -1 || cell.indexOf('total') > -1)">
							<div class="slds-select_container">
								<select class="slds-select" v-model="previousGifts8[cell].grade">
									<option v-for="grade in grades" :key="grade.name" 
										:value="grade.cssClass">{{grade.name}}</option>
								</select>
							</div>
						</div>
					</div>
				</td>
			</tr>
		</tbody>
		</table>
	</template>
	<!--Campaign analysis popup-->
	<div v-show="showFilterPopup">
		<section role="dialog" tabindex="-1" class="slds-modal slds-fade-in-open slds-modal_medium" aria-labelledby="modal-heading-01" aria-modal="true" aria-describedby="modal-content-id-1">
			<div class="slds-modal__container">
				<header class="slds-modal__header">
					<button class="slds-button slds-button_icon slds-modal__close slds-button_icon-inverse" title="Close"  v-on:click="closeFilterPopupModal()">
					<svg class="slds-button__icon slds-button__icon_large" aria-hidden="true">
						<use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#close"></use>
					</svg>
					<span class="slds-assistive-text">Close</span>
					</button>
					<h2 id="modal-heading-01" class="slds-modal__title slds-hyphenate">Analysis Report</h2>
				</header>
				<div class="slds-modal__content slds-p-around_medium" id="modal-content-id-1">
					<DonorAnalysis @searchData="searchCampaignData" ref="search"></DonorAnalysis>
				</div>
				<footer class="slds-modal__footer">
					
					<ul class="slds-button-group-list">
						<li>
							<button variant="primary" class="slds-button slds-button_neutral" v-on:click="resetFilters()">Reset Filters</button>
						</li>
						<li>
							<!--<router-link :to="{ name: 'CampaignReport', params: { filter:this.selectedFilter,isUpgradeAnalysisParam:this.isUpgradeAnalysisParam, isEmailAnalysisParam:this.isEmailAnalysisParam, subTotalExist: this.subTotalExist, IsFromSegments:false,campIdsArr:this.campIdsArr,subTotalFilter:this.subTotalFilter}}">
								<button variant="primary" class="slds-button slds-button_brand">Search</button>
							</router-link>-->
							<button variant="primary" class="slds-button slds-button_brand" @click="search();">Search</button>
						</li>
						<li>
							<button class="slds-button slds-button_neutral"  v-on:click="closeFilterPopupModal()">Cancel</button>
						</li>
					</ul>
				</footer>
			</div>
		</section>
		<div class="slds-backdrop slds-backdrop_open"></div>
	</div>
	<!--End-->
</div>
</template>

<script>
import DonorAnalysis from './DonorAnalysis';
import {getCampaignMemberFilterUrl, getCampaignUrl, getCampaignDetailsUrl} from '../config';
// Import component
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';

import TableHeadRow from './TableHeadRow';
import TableHeadCellFilter from './TableHeadCellFilter';

const CAMPAIGN_REPORT_TABLE_TYPE = 'Campaigns';
const SUMMARY_REPORT_TABLE_TYPE = 'Summary';
export default {
	name: 'DonorReport',
	components: {
		DonorAnalysis,
		Loading,
		TableHeadRow,
		TableHeadCellFilter
	},
	data() {
		return {
			templateArr: [],
			isLanded:true,
			isLoading:false,
			showFilterPopup:false,
			grades: [
				{name: ' - ', cssClass: ''}, 
				{name: 'Green', cssClass: 'green'}, 
				{name: 'Yellow', cssClass: 'yellow'}, 
				{name: 'Orange', cssClass: 'orange'}, 
				{name: 'Red', cssClass: 'red'}
				],
			amountRange: [0, 5, 10, 15, 20, 25, 35, 50, 100, 250, 500, 1000, 2000, 5000],
			monthRange: [0, 3, 5, 7, 9, 11, 12, 13, 15, 18, 24, 27, 36, 48, 60, 72],
			amountRangeLables: { '0':'$0-4.99', '5':'$5-$9.99', '10':'$10-$14.99', '15':'$15-$19.99', '20':'$20-$24.99', '25':'$25-$34.99','35':'$35-$49.99',
				'50':'$50-$99.99','100':'$100-$249.99','250':'$250-$499.99','500':'$500-$999.99','1000':'$1,000-$1,999','2000':'$2,000-$4,999','5000':'$5,000+','total':'Total'},
			previousGifts1: {},
			previousGifts2: {},
			previousGifts3: {},
			previousGifts5: {},
			previousGifts8: {},
			campaignData: [],
			campaignDetails: [],
			showList:false,
			showSummary:false,
			campaignExists:false,
			payload: {},
		}
	},
	filters: {
		toNumberFormat(value) {
			return `${value.toLocaleString()}`
		}
	},
	created: async function() {
		let routeParams = this.$route.params;
		console.log('filters'+JSON.stringify(routeParams));
		if(routeParams!=undefined && routeParams.isLanded){
			this.isLanded = true;
			return;
		}
	},
	mounted() {
		this.$root.$on("filterDataParent", (selectedFilter) => {
			this.getCampaignFilterData(selectedFilter);
		});
	},
	computed: {
		arrTemplate() {
			
			var result = this.tableAmountRange.reduce( (a, v) =>
				[...a, ...this.tableMonthRange.map(x=> [v,x].join('-'))],
			[]);
			return result.reduce((o, val) => { 
					let str = val; 
					o[val] = { 'count': (str.indexOf('rowLabel') > -1 ? this.amountRangeLables[str.replace('-rowLabel', '')] : 0), 'grade': ''}; return o; 
				}, {});
		}, 
		tableTemplate() {
			return this.tableAmountRange.map(x => this.tableMonthRange.map( y => `${x}-${y}`));
		},
		tableMonthRange() {
			let reverseMonthRange = [...this.monthRange].reverse();

			return ['rowLabel', ...reverseMonthRange, 'total'];
		},
		tableAmountRange() {
			return [...this.amountRange, 'total'];
		}
	},
	methods: {
		previousGiftsCalculated: function(data){
			let reducedData = data.reduce((acc, {previousGifts, giftCategorization, lapsedDonations, accountCounts}) => {
						acc[previousGifts] = acc[previousGifts]  || [];
						acc[previousGifts][`${giftCategorization}-${lapsedDonations}`] = {'count': accountCounts, 'grade': ''};
					return acc;
					}, []);

			let previousGiftJson = {};
			reducedData.forEach((el, index) => {

				if(el) {
					Object.keys(el).forEach(key => {
						let keysArr = key.split('-');
						if(!el[`${keysArr[0]}-total`]) {
							el[`${keysArr[0]}-total`] = {'count': 0, 'grade': ''};
						}
						if(!el[`total-${keysArr[1]}`]) {
							el[`total-${keysArr[1]}`] = {'count': 0, 'grade': ''};
						}
						if(!el['total-total']) {
							el['total-total'] = {'count': 0, 'grade': ''}
						}
						if(!(['rowLabel', 'total'].includes(keysArr[1]) || keysArr[0] == 'total')){
							el[keysArr[0]+ '-total'].count += el[key].count; 
							el[`total-${keysArr[1]}`].count += el[key].count; 
						}
						
						el['total-total'].count += el[key].count; 
					});

					previousGiftJson[index] = Object.assign({}, this.arrTemplate, el);
					
				}
			});

			return previousGiftJson;

		},
		updateCellColor: function (event, cellIdentifier) {
			cellIdentifier.grade = event.target.value;
		},
		showFilterPopupModal : function () {
			
			//this.$refs.search.setCampIds();
			this.showFilterPopup=true;
		},
		closeFilterPopupModal: function () {
			this.showFilterPopup=false;
		},
		resetFilters(){
			this.$refs.search.resetFilters();
		},
		search(){
			this.isLanded = false;
			this.showFilterPopup=false;
			this.$refs.search.searchDonors();
		},
		searchData(){
			this.isLoading = true;
			this.axios.post(getCampaignMemberFilterUrl, this.payload.filter)
				.then((response) => {
					let calculatedData = this.previousGiftsCalculated(response.data);
					this.previousGifts1 = calculatedData[1] ? calculatedData[1] : false;
					this.previousGifts2 = calculatedData[2] ? calculatedData[2] : false;
					this.previousGifts3 = calculatedData[3] ? calculatedData[3] : false;
					this.previousGifts5 = calculatedData[5] ? calculatedData[5] : false;
					this.previousGifts8 = calculatedData[8] ? calculatedData[8] : false;
					
					this.setTableView(SUMMARY_REPORT_TABLE_TYPE);

				}).catch((error => {
					this.showError(error);
				}))
		},
		searchCampaignData(payload){
			this.isLoading = true;
			this.closeFilterPopupModal();
			this.payload = payload;
			this.axios.post(getCampaignUrl, payload.filter)
				.then((response) => {
					this.campaignData = response.data;
					this.setTableView(CAMPAIGN_REPORT_TABLE_TYPE);
				}).catch((error => {
					this.showError(error);
				}))
		},
		getCampaignDetails: function(campaignId) {
			this.axios.post(getCampaignDetailsUrl + '?campaignId=' + campaignId)
				.then((response) => {
					this.campaignDetails = response.data;
				}).catch((error => {
					this.showError(error);
				}));
		},
		onCancel() {
			//console.log('User cancelled the loader.')
		},
		showError(error) {
			this.isLoading = false;
			this.$notify({
				group: 'error', type: 'error', duration: 4000,
				title: 'Error!',
				text: `Please report the query filters: ${error}`
			});
		},
		setTableView(tableType){
			this.isLoading = false;
			this.isRendered = true;
			this.showList = false;
			this.showSummary = false;
			switch(tableType) {
				case CAMPAIGN_REPORT_TABLE_TYPE: this.showList = true; break;
				case SUMMARY_REPORT_TABLE_TYPE: this.showSummary = true; break;
			}
		}
	}
}
</script>
<style scoped>
	table.autoNumber {
		counter-reset: rowNumber;
	}
	table.autoNumber tbody tr {
		counter-increment: rowNumber;
	}
	table.autoNumber tbody tr td:first-child::before {
		content: counter(rowNumber);
		min-width: 1em;
	}
	thead tr th {
		top: 0;
		border-bottom: 1px solid #dddbda;
		position: -webkit-sticky;
		position: sticky;
		z-index: 3;
	}

	table.summaryReport thead tr:last-child th {
		top: 25px;
		border-bottom: 1px solid #dddbda;
		position: -webkit-sticky;
		position: sticky;
		z-index: 1;
	}

	table.autoNumber thead tr:last-child th {
		top: 40px;
		border-bottom: 1px solid #dddbda;
		position: -webkit-sticky;
		position: sticky;
		z-index: 1;
	}

	tr th{
		position: -webkit-sticky;
		position: sticky;
		top: 0;
		z-index: 2;
	}

	th[scope=row] {
		position: -webkit-sticky;
		position: sticky;
		left: 0;
		z-index: 4;
		background-color: white;
		border-right: 1px solid #dddbda;
	}

	th:not([scope=row]):nth-of-type(2) {
		left: 0;
		z-index: 5; 
		border-right: 1px solid #dddbda;
	}

	tfoot th {
		bottom:0;
		border-top: 1px solid #dddbda;
		position: -webkit-sticky;
		position: sticky;
		z-index: 3;
		background-color: #fafaf9;
		color: #514f4d;
		padding: .25rem .5rem;
		font-weight: 700;
		line-height: normal;
	}

	.rowNumCol {
		width: 75px;
		text-align:center;
	}
	.campaignName {
		width: 175px;
	}
	.listText { 
		width: 65ch;
	}
	.selectText {
		width: 25ch;
	}
	.longText{
		width: 200px;
	}
	.numberCol, .dateCol {
		width: 125px;
	}
	.shortNumCol {
		width: 85px;
	}
	.campaignData {
		width: 150px;
	}
	.numStyle {
		text-align: right;
		padding: 0 0.3em;
	}
	.textColumn {
		white-space: pre-line;
	}

	.slds-form-element {
		padding: 0;
		text-align: center;
	}
	.green {
		background-color: #04844b;
	}
	.green .slds-form-element__label {
		color: #fff;
	}
	.yellow {
		background-color: #ffe654;
	}
	.orange {
		background-color: #f99221;
	}
	.red {
		background-color: #c23934;;
	}
	.red .slds-form-element__label {
		color: #fff;
	}
	table.summaryReport .slds-form-element__label {
		font-size: 1.15em;
		display: block;
		padding: 5px 5px 10px 0;
		text-align: right;
	}
	table.summaryReport .slds-select {
		font-size: 0.8em;
		height: calc(1.65rem + (1px *2));
		border-top: 0;
		border-radius: 0;
		border-right: 0;
		border-left: 0;
	}

	table.summaryReport .slds-form-element_stacked{
		margin-bottom: 0;
	}

	table.summaryReport tbody td:first-child .slds-form-element__label {
		font-size: 0.8em;
	}
	
	.slds-select_container:before {
		border-bottom: 5px solid #999;
	}

	.slds-select_container:after {
		border-top: 5px solid #999;
	}
	
</style>